export default __webpack_public_path__ + "static/media/a009-tip2.0637f57c.jpg";